import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: theme.narrowestContainerWidth,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(3),
    },
    card: {
      maxWidth: 420,
      width: '100%',
      padding: theme.spacing(4),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: COLORS.neutral.white,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    },
    title: {
      ...theme.typography.h5,
      marginBottom: theme.spacing(2),
      textAlign: 'center',
    },
    body: {
      ...theme.typography.regular16,
      color: COLORS.neutral.black,
      marginBottom: theme.spacing(4),
      textAlign: 'center',
    },
    infoBlock: {
      marginBottom: theme.spacing(1.5),
      padding: theme.spacing(2),
      backgroundColor: COLORS.gray.background,
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    changeLink: {
      marginBottom: theme.spacing(3),
      color: COLORS.neutral.mediumGray,
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    denyButton: {
      order: 2,
    },
  }),
  { name: 'OAuthConsentPage' }
);
